import React from 'react'

export const ProjectContext = React.createContext(0);